/* unplugin-vue-components disabled */import script from "./my-org-group-child-tree.vue?vue&type=script&setup=true&lang=js"
export * from "./my-org-group-child-tree.vue?vue&type=script&setup=true&lang=js"

import "./my-org-group-child-tree.vue?vue&type=style&index=0&id=70ecb54a&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70ecb54a"]])

export default __exports__